var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[(!this.src.includes("svga"))?_c('img',{staticClass:"prev-image",attrs:{"src":this.src,"alt":""}}):_c('v-uni-view',{attrs:{"id":"preview-svga"},on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.visible = false
}}})],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }